import React, { Component } from 'react';
import { Popover, OverlayTrigger } from "react-bootstrap";

class ItemsTable extends Component {
    state = {  }
    render() {
        let { datos, valorUc, valorUcNi } = this.props;
        const styles = {
            padding: 5, fontSize: 12
        }
        let menu = (
            <Popover bsSize="large" id="acciones">
                <div className="text-primary" onClick={() => {this.props.edit(datos.id, datos.item, datos.uc, datos.status)}} title="Modificar este registro" style={{cursor:"pointer", fontSize: 12, padding: 5}} style={{cursor:"pointer", fontSize: 13, padding: 5}}><i className="fa fa-edit"></i> Modificar</div>
                <div className="text-danger" onClick={() => {this.props.del(datos.id)}} title="Eliminar este registro" style={{cursor:"pointer", fontSize: 12, padding: 5}}><i className="fa fa-trash"></i> Eliminar</div>
            </Popover>
        )

        return (
            <React.Fragment>
                <tr height={40}>
                    <td style={styles}>{datos.item}</td>
                    <td style={styles} align="center">{datos.uc}</td>
                    <td style={styles} align="center">{((datos.uc) * valorUc).toFixed(2)} Bs</td>
                    <td style={styles} align="center">{((datos.uc) * valorUcNi).toFixed(2)} Bs</td>
                    <td style={styles} align="center">
                        <OverlayTrigger trigger="focus" placement="right" overlay={menu}>
                            <button className="btn btn-primary" title= "Haz click aqui para ver las opciones disponibles" style={{borderWidth: 1}}><i className="fa fa-gear"></i> Acciones</button>
                        </OverlayTrigger>
                    </td>
                </tr>
            </React.Fragment>
        );
    }
}
 
export default ItemsTable;


// WEBPACK FOOTER //
// ./src/views/Administracion/IngresosContent/ItemsTable.jsx